const defaultFlags = {
    education: false,
    'better-prototype-nav-bar': false,
    'presence-v2': false,
    'collaborative-editing': false,
    'page-load-metrics': false,
    'service-worker-caching': false,
    'mandatory-email-verification': false,
    'hubspot-chat-support': false,
    'workspace-members-filter': false,
    'report-subscriptions-to-sentry': false,
    'discover-news-hidden': false,
    'link-components-from-inspector': false,
    'public-api-manage-personal-tokens': false,
    'cwv-custom-grid': false,
    'restricted-uploads': false,
    'sketch-partners': false,
    'design-systems': false,
    'design-systems-editor': false,
    'components-description': false,
    'sessions-management': false,
    'duplicate-documents': false,
    'set-as-template': false,
    'color-tokens': false,
    'cross-tabs-token-refresh': false,
    'guests-in-project': false,
    'restricted-public-links': false,
    profiles: false,
    'resolve-annotations': false,
    'signout-refactory': false,
    'publish-community': false,
    'dark-mode-toggle': false,
    'user-permissions-directory': false,
    'scim-access': false,
    'pages-unread-annotations': false,
    sidebar: false,
    'multiple-authorizations': false,
    // these flags are used when user is not even signed in
    // it is expected that these flags will be changed
    // using DevTools
};

export { defaultFlags };
